<template>
  <div style="padding-bottom: 70px">
    <div class="case_content_wrap">
      <div class="case_content_wrapper">
        <div class="case_content_viewport">
          <ul
            class="case_content_list"
            :style="
              'transform: translate3d(-' + curIndex * 520 + 'px, 0px, 0px)'
            "
          >
            <li v-for="(item, index) in list" :key="index">
              <div class="item_img">
                <img :src="item.url" />
              </div>
              <div class="item_wrap">
                <div class="item_info">
                  <p class="item_title ellipsis">{{ item.title }}</p>
                  <!-- <p class="subtitle"></p> -->
                  <div class="description">
                    {{ item.name }}
                    <br />
                    {{ item.address }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="list_J_left" v-show="curIndex > 0">
          <img
            @click="goleft"
            style="width: 100%"
            src="@/image/index/cases_icon_left.png"
          />
        </div>
        <div class="list_J_right" v-show="curIndex < list.length - 2">
          <img
            @click="goright"
            style="width: 100%"
            src="@/image/index/cases_icon_left.png"
          />
        </div>
      </div>
    </div>
    <div @click="goStories" class="swiper-btn">更多</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curIndex: 0,
      clickLog: false,
      list: [
        {
          url: require("@/image/index/icon_ttx.png"),
          title: "途途行",
          name: "云南省28家道路运输企业联合打造互联网服务平台",
          address: "",
        },
        {
          url: require("@/image/index/icon_thcx.png"),
          title: "泰禾出行",
          name: "广西钦州泰禾运输集团综合出行平台",
          address: "",
        },
        {
          url: require("@/image/index/icon_gacx.png"),
          title: "广安出行",
          name: "四川省广安市本地综合出行平台",
          address: "",
        },
        {
          url: require("@/image/index/icon_hjcx.png"),
          title: "红交出行",
          name: "云南交运集团综合出行平台",
          address: "",
        },
        {
          url: require("@/image/index/icon3.png"),
          title: "寻乌出行",
          name: "赣州市寻乌县定制快车平台",
          address: "",
        },
        {
          url: require("@/image/index/icon1.png"),
          title: "全南出行",
          name: "赣州市全南县定制快车平台",
          address: "",
        },
        {
          url: require("@/image/index/icon_hccx.png"),
          title: "会昌出行",
          name: "赣州市会昌县定制快车平台",
          address: "",
        },
        {
          url: require("@/image/index/icon5.png"),
          title: "莲花出行",
          name: "萍乡市莲花县本地出行平台",
          address: "",
        },
        {
          url: require("@/image/index/icon_wycx.png"),
          title: "万源出行",
          name: "四川万源市定制快车平台",
          address: "",
        },
        {
          url: require("@/image/index/icon7.png"),
          title: "长阳出行",
          name: "宜昌市长阳县本地出行平台",
          address: "",
        },
        // {
        //   url: require("@/image/index/icon1.png"),
        //   title: "全南快车",
        //   name: "公司名称：江西省全鑫汽运有限公司",
        //   address: "公司地址：江西省赣州市全南县",
        // },
        // {
        //   url: require("@/image/index/icon2.png"),
        //   title: "龙南快车",
        //   name: "公司名称：江西新世纪集团龙南县长运有限公司",
        //   address: "公司地址：江西省赣州市龙南县",
        // },
        // {
        //   url: require("@/image/index/icon3.png"),
        //   title: "寻乌快车",
        //   name: "公司名称：江西新世纪汽运集团寻乌客货运输有限公司",
        //   address: "公司地址：江西省赣州市寻乌县",
        // },
        // {
        //   url: require("@/image/index/icon4.png"),
        //   title: "石城快车",
        //   name: "公司名称：江西新世纪汽运集团石城交运有限公司",
        //   address: "公司地址：江西省赣州市石城县",
        // },
        // {
        //   url: require("@/image/index/icon5.png"),
        //   title: "莲花出行",
        //   name: "公司名称：莲花县公共交通汽车运输有限公司",
        //   address: "公司地址：江西省萍乡市莲花县",
        // },
        // {
        //   url: require("@/image/index/icon6.png"),
        //   title: "永新出行",
        //   name: "公司名称：永新县鸿运达客运汽车有限责任公司",
        //   address: "公司地址：江西省吉安市永新县",
        // },
        // {
        //   url: require("@/image/index/icon7.png"),
        //   title: "长阳出行",
        //   name: "公司名称：长阳土家族自治县平安出租客运有限公司",
        //   address: "公司地址：湖北省宜昌市长阳土家族自治县",
        // },
        // {
        //   url: require("@/image/index/icon8.png"),
        //   title: "安福出行",
        //   name: "公司名称：安福县春晖出租汽车有限公司",
        //   address: "公司地址：江西省吉安市安福县",
        // },
        // {
        //   url: require("@/image/index/icon9.png"),
        //   title: "荆楚同安出行",
        //   name: "公司名称：公安县同安出租车有限责任公司",
        //   address: "公司地址：湖北省公安县",
        // },
        // {
        //   url: require("@/image/index/icon10.png"),
        //   title: "盛星出行",
        //   name: "公司名称：抚州盛星公共交通有限公司",
        //   address: "公司地址：江西省抚州市",
        // },
      ],
    };
  },
  methods: {
    goleft() {
      if (this.clickLog || this.curIndex == 0) return;
      this.clickLog = true;
      this.curIndex -= 1;
      setTimeout(() => {
        this.clickLog = false;
      }, 500);
    },
    goright() {
      if (this.clickLog) return;
      this.clickLog = true;
      this.curIndex += 1;
      setTimeout(() => {
        this.clickLog = false;
      }, 500);
    },
    goStories() {
      this.$router.push({ name: "stories" });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl';
</style>


// WEBPACK FOOTER //
// src/components/swiperpro/index.vue